import React, { useEffect, useState } from 'react';
import { Container, Typography, Grid, Button, TextInput } from '../../canvasComponents/index';
import '../../css/domain/Services/Services.scss';
import { FormattedMessage, useIntl, injectIntl } from 'react-intl';
import messages from './messages';
import { getRouteUrl } from '../../FormioComponents/utils';
import useLeavingPageHandler from '../../hooks/useLeavingPageHandler';

function Uber({ onFinalContinue, saveAndContinueLater, updateClaim, claimId, serviceData, lastStep, updateCurrentPage, uberAmount }) {
  const [step, setStep] = useState(lastStep || 'UberPhoneNumber');
  const [phoneNumber, setPhoneNumber] = useState(serviceData?.phoneNumber);
  const [errorMessage, setErrorMessage] = useState(false);
  const [errorMessageStartWith1, setErrorMessageStartWith1] = useState(false);
  // data to save to DB
  const [dbData, setDbData] = useState({ ...serviceData, isUberVisible: true, triggerUber: true });
  const [isUpdateRequired, setIsUpdateRequired] = useState(false);
  // data for review page
  const [uber, setUber] = useState({
    isUberVisible: true,
    triggerUber: true,
    phoneNumber,
    claimId,
    previousStep: () => handleEditCallback(),
  });
  const { isLeavingSoSoonPopUpOpen } = useLeavingPageHandler('Vehicle', document.querySelector('.services-heading')?.textContent, true);
  useEffect(() => {
    window.history.pushState({}, window.location.pathname, `#/${getRouteUrl(document.querySelector('.services-heading')?.textContent, 'Vehicle') || ''}`);
  }, [step]);

  const intl = useIntl();

  const handleEditCallback = () => {
    setStep('UberPhoneNumber');
  };

  useEffect(() => {
    if (isLeavingSoSoonPopUpOpen) {
      document.getElementById('leave-popup-button').addEventListener('click', () => {
        saveAndContinueLater('uber', step, dbData);
      });
    }
  }, [isLeavingSoSoonPopUpOpen]);
  useEffect(() => {
    setUber((prev) => ({ ...prev, claimId }));
  }, [claimId]);

  useEffect(() => {
    setUber((prev) => ({ ...prev, phoneNumber }));
    setDbData({ ...dbData, phoneNumber });
  }, [phoneNumber]);

  const onClickContinue = (nextPage) => {
    switch (nextPage) {
      case 'UberVoucherConfirmation':
        if (phoneNumber[1] === '1') {
          setErrorMessage(true);
          setErrorMessageStartWith1(true);
          return;
        }
        setErrorMessageStartWith1(false);
        if (!phoneNumber || phoneNumber.length < 14) {
          setErrorMessage(true);
          return;
        }
        break;
      case 'servicesReview':
        setIsUpdateRequired(true);
        onFinalContinue({ ...uber });
        return;
      default:
        break;
    }
    setIsUpdateRequired(true);
    setStep(nextPage);
  };

  useEffect(() => {
    if (isUpdateRequired) {
      updateClaim('uber', step, dbData);
      setIsUpdateRequired(false);
    }
  }, [isUpdateRequired]);

  useEffect(() => {
    switch (step) {
      case 'UberPhoneNumber':
        updateCurrentPage(messages.uberVoucher, 2);
        break;
      case 'UberVoucherConfirmation':
        updateCurrentPage(messages.getReady, 3);
        break;
      default:
        updateCurrentPage(messages.uberVoucher, 2);
    }
    // Scroll to the page top
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }, [step]);

  return (
    <>
      {step === 'UberPhoneNumber' && (
        <Container fluid className="dashboard-content">
          <Grid>
            <Grid.Row>
              <Typography h1 center className="services-heading">
                <FormattedMessage {...messages.uberVoucher} />
              </Typography>
            </Grid.Row>
            <div className="services-divider services-copy">
              <Grid.Row justifyContentCenter flex>
                <p className="subtitle mb-8">
                  <FormattedMessage {...messages.howItWorks} />
                </p>
                <ul className="services-list">
                  <li><FormattedMessage {...messages.list1} /></li>
                  <li><FormattedMessage {...messages.list2} /></li>
                  <li><FormattedMessage {...messages.list3} /></li>
                  <li><FormattedMessage {...messages.list4} /></li>
                </ul>
                <p><strong><FormattedMessage {...messages.headsup} /></strong> <FormattedMessage {...messages.uberVouchers} values={{ uberAmount }} /></p>
              </Grid.Row>
            </div>

            <div className="services-divider">
              <Grid.Row>
                <div>
                  <TextInput
                    label={intl.formatMessage({ ...messages.phoneNumberText })}
                    mask="(999) 999-9999"
                    placeholder="(XXX) XXX-XXXX"
                // eslint-disable-next-line no-unused-expressions
                    onChange={(value) => { setPhoneNumber(value); value.length === 14 && setErrorMessage(''); }}
                    value={phoneNumber}
                    defaultValue={phoneNumber !== '' ? phoneNumber : ''}
                    className="text-input-width fs-exclude"
                  />
                </div>
                {errorMessage && (errorMessageStartWith1 ? <p className="error-message"> <FormattedMessage {...messages.phoneErrorStart1} /></p> : <p className="error-message"> <FormattedMessage {...messages.phoneError} /></p>)}
              </Grid.Row>
            </div>

            <Grid.Row justifyContentCenter flex>
              <div className="center-v services-btns">
                <Button
                  primary
                  className="mb-20 services-continue-button"
                  onClick={() => onClickContinue('UberVoucherConfirmation')}
                ><FormattedMessage {...messages.continueCta} />
                </Button>
                <Button
                  className="btn save-continue-later"
                  onClick={() => saveAndContinueLater('uber', step, dbData)}
                >
                  <FormattedMessage {...messages.saveContinueCta} />
                </Button>
              </div>
            </Grid.Row>
          </Grid>
        </Container>
      )}

      {step === 'UberVoucherConfirmation' && (
        <Container fluid className="dashboard-content">
          <Grid>
            <Grid.Row>
              <Typography h1 center className="services-heading">
                <FormattedMessage {...messages.getReady} />
              </Typography>
            </Grid.Row>
            <div className="services-divider services-copy">
              <Grid.Row>
                <div className="mb-16">
                  <p>
                    <FormattedMessage {...messages.uberText} values={{ uberAmount }} />
                  </p>
                </div>
                <div className="text-input-width">
                  <p className="mb-16 disabled-input disabled-number centered-text-input fs-exclude">
                    {`(***) ***-${phoneNumber.substring(10, 14)}`}
                  </p>
                </div>
                <p><FormattedMessage {...messages.uberContinueText1} /><strong><FormattedMessage {...messages.uberContinueText2} /></strong><FormattedMessage {...messages.uberContinueText3} /></p>
              </Grid.Row>
            </div>
            <Grid.Row justifyContentCenter flex>
              <div className="center-v services-btns">
                <Button
                  primary
                  className="mb-20 services-continue-button"
                  onClick={() => onClickContinue('servicesReview')}
                ><FormattedMessage {...messages.continueCta} />
                </Button>
                <Button
                  className="btn save-continue-later"
                  onClick={() => saveAndContinueLater('uber', step, dbData)}
                >
                  <FormattedMessage {...messages.saveContinueCta} />
                </Button>
              </div>
            </Grid.Row>
          </Grid>
        </Container>
      )}
    </>
  );
}

export default injectIntl(Uber);
